import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SiteDto } from '@dto';
import { GlobalAlertService, SiteService } from 'src/app/services';

@Injectable({ providedIn: 'root' })
export class SiteResolver {
  constructor(
    private siteService: SiteService,
    private globalAlertService: GlobalAlertService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<SiteDto> {
    const siteId = route.queryParamMap.get('siteId') || route.paramMap.get('siteId');

    return this.siteService.getSite$(siteId, true, true).pipe(
      catchError((err: unknown) => {
        this.globalAlertService.setError(err.toString());
        return throwError(() => new Error(err.toString()));
      }),
    );
  }
}
